module.exports = "/_next/static/images/2471fd200e5a95e7cf6e4519e09c0da3-Nubank_HickDuarte_58741_md.jpg.webp";